import { Checkbox } from 'plume-ui';
import { useTranslation } from 'react-i18next';

import useFormControls from '../../Monitor/components/OutreachConfigForm/hooks/useFormControls';
import {
  OutreachConfigGenericFormField,
  SupportOutreachTriggerFormFields,
} from '../../Monitor/types';

export type OutreachConfigFieldMessagesProps<T> = {
  propertyName: OutreachConfigGenericFormField<T>['name'];
} & Omit<OutreachConfigGenericFormField<T>, 'name'>;

const weekdays = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];

function OutreachConfigWeekdays<T extends any>({
  field,
  form,
}: OutreachConfigFieldMessagesProps<T>) {
  const { getPropertyValue, setPropertyValue } = useFormControls<T>(
    field,
    form,
  );
  const { t } = useTranslation();

  // @TODO: Consider fetching data from metadata to display allowed weekdays

  const onWeekdayChecked = (weekday: string) => {
    const current = [
      ...(getPropertyValue(
        SupportOutreachTriggerFormFields.TimeRepeatWeekdays as keyof T,
      ) as string),
    ];
    const index = current.indexOf(weekday);
    if (index !== -1) {
      delete current[index];
      setPropertyValue(
        SupportOutreachTriggerFormFields.TimeRepeatWeekdays as keyof T,
        current.filter((d) => d) as T[keyof T],
      );
      return;
    }
    setPropertyValue(
      SupportOutreachTriggerFormFields.TimeRepeatWeekdays as keyof T,
      [...current, weekday] as T[keyof T],
    );
  };

  return (
    <div className="OutreachContainer__subscriber-outreach-trigger-field OutreachContainer__subscriber-outreach-trigger-field--weekdays">
      {weekdays.map((day: string) => (
        <Checkbox
          key={day}
          onChange={() => onWeekdayChecked(day)}
          checked={(getPropertyValue(
            SupportOutreachTriggerFormFields.TimeRepeatWeekdays as keyof T,
          ) as string[]).includes(day)}
          label={t(`weekdays.${day}`)}
        />
      ))}
    </div>
  );
}

export default OutreachConfigWeekdays;
